import { render, staticRenderFns } from "./topBtn.vue?vue&type=template&id=b064dbf2"
import script from "./topBtn.vue?vue&type=script&lang=js"
export * from "./topBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports